import { render, staticRenderFns } from "./BaseAccount.vue?vue&type=template&id=d4505ba0&scoped=true"
import script from "./BaseAccount.vue?vue&type=script&lang=js"
export * from "./BaseAccount.vue?vue&type=script&lang=js"
import style0 from "./BaseAccount.vue?vue&type=style&index=0&id=d4505ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4505ba0",
  null
  
)

export default component.exports